export enum ResourceCopilotDataEventObjectsEnum {
  AI_RESOURCE_COPILOT_OUTCOME = 'ai_resource_copilot_outcome',
}

export enum ResourceCopilotOutcomesEnum {
  SAVED = 'saved',
  DISCARDED = 'discarded',
  ABANDONED = 'abandoned',
  REFINED = 'refined',
}
